import React from 'react';
import styled from 'styled-components';

const PolicyContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px;
  min-height: 70vh;
`;

const Title = styled.h1`
  text-align: center;
  color: #333;
  margin-bottom: 20px;
  font-size: 2.5rem;
  font-weight: 700;
`;

const Subtitle = styled.p`
  text-align: center;
  color: #666;
  margin-bottom: 60px;
  font-size: 1.2rem;
  max-width: 800px;
  margin: 0 auto 60px;
`;

const Section = styled.div`
  margin-bottom: 50px;
  background: #f8f9fa;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
`;

const SectionTitle = styled.h2`
  color: #333;
  margin-bottom: 25px;
  font-size: 1.8rem;
  font-weight: 600;
`;

const SectionContent = styled.div`
  color: #555;
  line-height: 1.8;
  font-size: 1.1rem;
  
  p {
    margin-bottom: 15px;
  }
  
  ul, ol {
    margin: 15px 0;
    padding-left: 30px;
    
    li {
      margin-bottom: 10px;
    }
  }
  
  strong {
    color: #333;
    font-weight: 600;
  }
`;

const ContactInfo = styled.div`
  background: #f8f9fa;
  padding: 30px;
  border-radius: 15px;
  text-align: center;
  margin-top: 40px;
`;

const ContactTitle = styled.h3`
  color: #333;
  margin-bottom: 20px;
  font-size: 1.4rem;
`;

const ContactItem = styled.div`
  margin-bottom: 15px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const ContactLabel = styled.span`
  color: #555;
  margin-right: 10px;
`;

const ContactValue = styled.span`
  color: #4CAF50;
  font-weight: 600;
`;

const PersonalDataConsent = () => {
  return (
    <PolicyContainer>
      <Title>Согласие на обработку персональных данных</Title>
      <Subtitle>
        Настоящее Согласие определяет порядок обработки персональных данных пользователей сайта foodstar.pro при использовании сервисов аналитики
      </Subtitle>

      <Section>
        <SectionTitle>1. Общие положения</SectionTitle>
        <SectionContent>
          <p>
            Настоящее Согласие на обработку персональных данных (далее — «Согласие») предоставляется Обществу с ограниченной ответственностью «Лагом Лайф» (далее — «Оператор»), расположенному по адресу: 446301, Самарская область, г. Отрадный, Спортивная ул., д. 7, ОГРН 1246300002409, ИНН 6318073403, КПП 637201001.
          </p>
          <p>
            Настоящее Согласие действует в отношении обработки персональных данных, полученных при использовании сайта foodstar.pro и сервисов аналитики, включая Яндекс.Метрику и пиксель ВКонтакте.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>2. Цели обработки персональных данных</SectionTitle>
        <SectionContent>
          <p>
            Оператор обрабатывает персональные данные в следующих целях:
          </p>
          <ul>
            <li>Анализ поведения пользователей на сайте для улучшения его работы</li>
            <li>Сбор статистики посещений и использования сайта</li>
            <li>Измерение эффективности рекламных кампаний</li>
            <li>Персонализация контента и рекламы</li>
            <li>Обеспечение безопасности и предотвращение мошенничества</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>3. Состав обрабатываемых персональных данных</SectionTitle>
        <SectionContent>
          <p>
            При использовании сервисов аналитики могут обрабатываться следующие персональные данные:
          </p>
          <ul>
            <li>IP-адрес (в обезличенном виде)</li>
            <li>Информация об устройстве (тип устройства, операционная система, версия браузера)</li>
            <li>Информация о посещенных страницах сайта</li>
            <li>Время и продолжительность посещения страниц</li>
            <li>Источник перехода на сайт</li>
            <li>Географическое расположение (страна, город, регион)</li>
            <li>Данные о действиях пользователя на сайте (клики, прокрутка, переходы)</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>4. Использование сервисов аналитики</SectionTitle>
        <SectionContent>
          <p>
            <strong>4.1. Яндекс.Метрика</strong>
          </p>
          <p>
            На сайте используется Яндекс.Метрика — веб-аналитический сервис компании Яндекс (ООО «Яндекс»), который собирает и обрабатывает данные о посещениях сайта.
          </p>
          <p>
            Яндекс.Метрика обрабатывает следующие данные:
          </p>
          <ul>
            <li>IP-адрес пользователя (в обезличенном виде)</li>
            <li>Информация об устройстве и браузере</li>
            <li>Страницы, которые посещает пользователь</li>
            <li>Время, проведенное на сайте</li>
            <li>Источник перехода на сайт</li>
            <li>Действия пользователя на сайте</li>
          </ul>
          <p>
            Данные обрабатываются в соответствии с Политикой конфиденциальности Яндекс.Метрики: <a href="https://yandex.ru/legal/confidential/" target="_blank" rel="noopener noreferrer">https://yandex.ru/legal/confidential/</a>
          </p>
          <p>
            Вы можете отказаться от сбора данных Яндекс.Метрикой, установив специальное расширение для браузера: <a href="https://yandex.ru/support/metrica/general/opt-out.html" target="_blank" rel="noopener noreferrer">https://yandex.ru/support/metrica/general/opt-out.html</a>
          </p>

          <p>
            <strong>4.2. Пиксель ВКонтакте</strong>
          </p>
          <p>
            На сайте используется пиксель ВКонтакте (VK Pixel) — инструмент для отслеживания конверсий и ретаргетинга, предоставляемый компанией ВКонтакте (ООО «В Контакте»).
          </p>
          <p>
            Пиксель ВКонтакте обрабатывает следующие данные:
          </p>
          <ul>
            <li>IP-адрес пользователя</li>
            <li>Информация об устройстве</li>
            <li>Данные о посещенных страницах</li>
            <li>Действия пользователя на сайте (просмотры, добавления в корзину, покупки)</li>
            <li>Идентификатор пользователя ВКонтакте (если пользователь авторизован в ВКонтакте)</li>
          </ul>
          <p>
            Данные обрабатываются в соответствии с Политикой конфиденциальности ВКонтакте: <a href="https://vk.com/privacy" target="_blank" rel="noopener noreferrer">https://vk.com/privacy</a>
          </p>
          <p>
            Вы можете управлять настройками рекламы ВКонтакте в разделе настроек вашего аккаунта: <a href="https://vk.com/settings?act=ads" target="_blank" rel="noopener noreferrer">https://vk.com/settings?act=ads</a>
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>5. Способы обработки персональных данных</SectionTitle>
        <SectionContent>
          <p>
            Обработка персональных данных осуществляется с использованием средств автоматизации и без использования таких средств, включая:
          </p>
          <ul>
            <li>Сбор и запись персональных данных</li>
            <li>Систематизация и хранение персональных данных</li>
            <li>Использование персональных данных для анализа и статистики</li>
            <li>Передача персональных данных третьим лицам (Яндекс.Метрика, ВКонтакте) в соответствии с настоящим Согласием</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>6. Сроки обработки персональных данных</SectionTitle>
        <SectionContent>
          <p>
            Персональные данные обрабатываются в течение срока, необходимого для достижения целей обработки, указанных в разделе 2 настоящего Согласия, или до момента отзыва Согласия субъектом персональных данных.
          </p>
          <p>
            Данные, собранные Яндекс.Метрикой, хранятся в соответствии с политикой хранения данных Яндекс.Метрики.
          </p>
          <p>
            Данные, собранные пикселем ВКонтакте, хранятся в соответствии с политикой хранения данных ВКонтакте.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>7. Права субъекта персональных данных</SectionTitle>
        <SectionContent>
          <p>
            В соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных», вы имеете право:
          </p>
          <ul>
            <li>Получать информацию, касающуюся обработки ваших персональных данных</li>
            <li>Требовать уточнения персональных данных, их блокирования или уничтожения</li>
            <li>Отозвать согласие на обработку персональных данных</li>
            <li>Обжаловать действия или бездействие Оператора в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке</li>
            <li>Получать информацию о третьих лицах, которым передаются ваши персональные данные</li>
          </ul>
          <p>
            Для реализации ваших прав вы можете обратиться к Оператору по контактным данным, указанным в разделе 9 настоящего Согласия.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>8. Отзыв согласия на обработку персональных данных</SectionTitle>
        <SectionContent>
          <p>
            Вы имеете право отозвать согласие на обработку персональных данных в любое время, направив письменное уведомление Оператору по адресу: 446301, Самарская область, г. Отрадный, Спортивная ул., д. 7, или на электронную почту: lagomlife@mail.ru.
          </p>
          <p>
            После отзыва согласия Оператор прекращает обработку персональных данных и уничтожает их в срок, не превышающий 30 дней с момента получения отзыва, если иное не предусмотрено договором, стороной которого является субъект персональных данных, или иным соглашением между Оператором и субъектом персональных данных.
          </p>
          <p>
            Обратите внимание, что отзыв согласия на обработку персональных данных может повлечь невозможность использования некоторых функций сайта.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>9. Контактная информация</SectionTitle>
        <SectionContent>
          <p>
            По всем вопросам, связанным с обработкой персональных данных, вы можете обращаться к Оператору:
          </p>
          <ul>
            <li>Почтовый адрес: 446301, Самарская область, г. Отрадный, Спортивная ул., д. 7</li>
            <li>Email: lagomlife@mail.ru</li>
            <li>ИНН: 6318073403</li>
            <li>КПП: 637201001</li>
            <li>ОГРН: 1246300002409</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>10. Заключительные положения</SectionTitle>
        <SectionContent>
          <p>
            Настоящее Согласие действует с момента начала использования сайта и сервисов аналитики до момента отзыва согласия субъектом персональных данных.
          </p>
          <p>
            Оператор оставляет за собой право вносить изменения в настоящее Согласие. При внесении изменений в актуальной редакции указывается дата последнего обновления.
          </p>
          <p>
            Дата последнего обновления: {new Date().toLocaleDateString('ru-RU', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </SectionContent>
      </Section>

      <ContactInfo>
        <ContactTitle>Контактная информация</ContactTitle>
        <ContactItem>
          <ContactLabel>Адрес:</ContactLabel>
          <ContactValue>446301, Самарская область, г. Отрадный, Спортивная ул., д. 7</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>ИНН:</ContactLabel>
          <ContactValue>6318073403</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>КПП:</ContactLabel>
          <ContactValue>637201001</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>ОГРН:</ContactLabel>
          <ContactValue>1246300002409</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>Email:</ContactLabel>
          <ContactValue>lagomlife@mail.ru</ContactValue>
        </ContactItem>
      </ContactInfo>
    </PolicyContainer>
  );
};

export default PersonalDataConsent;
